<template>
  <div>
    <el-card>
        <el-button type="primary" @click="query">新增</el-button>
    </el-card>
    <el-card>
      <el-table :data="list" v-loading="loading" border style="width: 100%">
        <el-table-column prop="typeName" label="类型"></el-table-column>
        <el-table-column prop="tabName" label="标签名称"></el-table-column>
        <el-table-column prop="templateName" label="模板名称"></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="formattercreateTime"
          width="200"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="details(scope.row.id)">详情 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pagination-wrapper" type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :current-page.sync="page.pageNum"
          :page-size.sync="page.pageSize"
          :total="page.total"
          @current-change="onCurrentChange"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      memberInfo: "",
      list: [],
      loading: false,
      value: "",
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tabTypeId:''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    formattercreateTime(row) {
      return this.getDate(row.createTime);
    },
    query() {
      this.$router.push({ path: "programmeAdd",query:{tabTypeId:this.tabTypeId}});
    },
    details(id){
      this.$router.push({ path: "programmeAdd",query: { id: id,tabTypeId:this.tabTypeId }});
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getMedicineList();
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.tab.type.template.list",
          pageNum: _this.page.pageNum,
          pageSize: _this.page.pageSize,
          tabTypeId: _this.$route.query.id,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.list = obj.sanboManagerTemplateList;
            _this.page.total = obj.amout;
            _this.tabTypeId=obj.sanboManagerTemplateVo.tabTypeId;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>
<style scoped>
</style>